import { Controller } from '@hotwired/stimulus'

// Динамическое добавление/удаление вложенных fields_for-блоков.
// Добавь новую строку по нажатию "+" и пометь существующую _destroy=1 при удалении.
//
// HTML контракт:
//   <div data-controller="nested-list" data-nested-list-prefix-value="promo_conditions_attributes">
//     <div data-nested-list-target="list">
//       <%# существующие строки рендерятся в Rails %>
//     </div>
//     <template data-nested-list-target="template">
//       <%# заготовка новой строки, index в name = NEW_RECORD %>
//     </template>
//     <button data-action="nested-list#add">+</button>
//   </div>
//
//   В каждой строке кнопка удаления:
//     <button data-action="nested-list#remove">×</button>
//   и скрытое поле:
//     <input type="hidden" name="...[_destroy]" value="0" data-destroy-flag>
export default class extends Controller {
  static targets = ['list', 'template']
  static values = { prefix: String }

  add (event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.listTarget.insertAdjacentHTML('beforeend', html)
  }

  remove (event) {
    event.preventDefault()
    const row = event.target.closest('.nested-row')
    if (!row) return

    const destroyFlag = row.querySelector('[data-destroy-flag]')
    const idInput = row.querySelector('input[name$="[id]"]:not([disabled])')

    if (idInput) {
      // Существующая запись — помечаем для удаления, прячем
      if (destroyFlag) destroyFlag.value = '1'
      row.style.display = 'none'
    } else {
      // Новая запись — просто убираем из DOM
      row.remove()
    }
  }
}
